import { Separator } from "@radix-ui/react-context-menu";
import { Button } from "antd";
import React from "react";

export default function Cart({ booking }) {
  const cartItems = booking?.booking?.cart || [];

  const subtotal = cartItems.reduce((acc, product) => {
    const price = product?.product?.price || 0;
    const discount = product?.product?.discountPercentage || 0;
    const discountedPrice = price - (price * discount / 100);
    return acc + (discountedPrice * (product?.quantity || 1));
  }, 0);

  return (
    <div className="rounded-lg"> 
      <div className="flex flex-col gap-8">
        {/* Cart Items */}
        <div className="flex-1">
          {cartItems.length === 0 ? (
            <div className="bg-white p-8 rounded-lg shadow-sm text-center">
              <div className="text-gray-400 text-lg mb-2">🛒</div>
              <p className="text-gray-500 font-medium">Cart is Empty</p>
            </div>
          ) : (
            <div className="space-y-4 max-h-[500px] overflow-y-auto pr-2">
              {cartItems.map((product, index) => {
                const prod = product?.product || {};
                const quantity = product?.quantity || 1;
                const price = prod.price || 0;
                const discount = prod.discountPercentage || 0;
                const discountedPrice = price - (price * discount / 100);

                return (
                  <div
                    key={index}
                    className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-all border border-gray-100"
                  >
                    <div className="flex flex-col sm:flex-row gap-4">
                      <div className="flex-shrink-0">
                        <img
                          width={160}
                          height={160}
                          className="rounded-lg object-cover w-40 h-40"
                          src={`${prod.image}`}
                          alt={prod.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://via.placeholder.com/160?text=No+Image';
                          }}
                        />
                      </div>

                      <div className="flex-1">
                        <div className="flex justify-between items-start">
                          <div>
                            <h3 className="text-lg font-semibold text-gray-800">
                              {prod.name}
                            </h3>
                            <p className="text-sm text-gray-500 mt-1">
                              {prod.description}
                            </p>
                          </div>
                          <span className={`px-2 py-1 text-xs rounded-full ${
                            product.approved
                              ? 'bg-green-100 text-green-800'
                              : 'bg-yellow-100 text-yellow-800'
                          }`}>
                            {product.approved ? 'Approved' : 'Pending'}
                          </span>
                        </div>

                        <div className="mt-3 grid grid-cols-2 gap-2 text-sm">
                          <div>
                            <span className="text-gray-500">Quantity:</span>
                            <span className="ml-2 font-medium">{quantity}</span>
                          </div>
                          <div>
                            <span className="text-gray-500">Model:</span>
                            <span className="ml-2 font-medium">{prod.model || 'N/A'}</span>
                          </div>
                          <div>
                            <span className="text-gray-500">GST:</span>
                            <span className="ml-2 font-medium">{prod.gstPercentage || 0}%</span>
                          </div>
                          <div>
                            <span className="text-gray-500">HSN:</span>
                            <span className="ml-2 font-medium">{prod.hsnCode || 'N/A'}</span>
                          </div>
                        </div>

                        <div className="mt-4">
                          {discount > 0 && (
                            <div className="flex items-center gap-2">
                              <span className="text-sm text-gray-500 line-through">
                                ₹{price.toFixed(2)}
                              </span>
                              <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded">
                                {discount}% OFF
                              </span>
                            </div>
                          )}
                          <p className="text-xl font-bold text-gray-900 mt-1">
                            ₹{discountedPrice.toFixed(2)}
                          </p>
                        </div>
                      </div>
                    </div>

                    {product.addedByPartner && (
                      <div className="mt-3 pt-3 border-t border-gray-100 text-sm text-gray-500">
                        Added by: {product.addedByPartner.profile.name}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Summary */}
        <div className="lg:w-80 flex-shrink-0">
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 sticky top-4">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Order Summary</h3>

            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-gray-600">Subtotal</span>
                <span className="font-medium">₹{subtotal.toFixed(2)}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">GST (inclusive)</span>
                <span className="font-medium">
                  ₹{(subtotal * 0.18).toFixed(2)} (18%)
                </span>
              </div>

              <Separator className="my-2 border-t border-gray-200" />

              <div className="flex justify-between text-lg font-bold">
                <span>Total</span>
                <span>₹{(subtotal).toFixed(2)}</span>
              </div>
            </div>

            {/* <Button
              type="primary"
              block
              size="large"
              className="mt-6 bg-blue-600 hover:bg-blue-700"
            >
              Proceed to Checkout
            </Button>

            <p className="text-xs text-gray-400 mt-3 text-center">
              Prices include all applicable taxes
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
}
